import { Pregunta } from './pregunta.model';

export class Respuesta {
  id_respuesta: number;
  id_pregunta: number;
  id_cuestionario: number;
  respuesta: string;
  solucion_evi: any;
  solucion_pregunta: Array<Pregunta>;
  solucion_pregunta_asociada: Array<any>;
  editar: boolean;

  constructor(){
    this.id_pregunta = 0;
    this.respuesta = "";
    this.id_respuesta = 0;
    this.solucion_evi = [];
    this.solucion_pregunta = [];
    this.solucion_pregunta_asociada = [];
    this.editar = false;
    this.id_cuestionario = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/respuesta.model.ts